export const PAGE_CONTAINER_ID = 'page-container';
